module.exports = __webpack_public_path__ + "img/real-name-auth.0a5fd721.png";